export const transformProjectToLogoEnrichment = ({ seller = {}, ...rest }) => ({
    sellerId: seller?.id,
    ...rest,
});
